(function() {
    'use strict';

    angular
        .module('sgnmrApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('norma', {
            parent: 'entity',
            url: '/norma?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.home.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/normas.html',
                    controller: 'NormaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,desc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('tipoDisposicion');
                    $translatePartialLoader.addPart('tipoModificacion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('norma.nuevo', {
            parent: 'norma',
            url: '/nuevo',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaEmisionPend: false,
                                fechaEmisionPendText: null,
                                fechaPublicacion: null,
                                fechaPublicacionPend: false,
                                fechaPublicacionPendText: null,
                                fechaDOF: null,
                                fechaDOFPend: false,
                                fechaDOFPendText: null,
                                fechaSJFYG: null,
                                fechaSJFYGPend: false,
                                fechaSJFYGPendText: null,
                                fechaSJFGaceta: null,
                                fechaSJFGacetaPend: false,
                                fechaSJFGacetaPendText: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: true,
                                abrogado: false,
                                disposicion: 'EXPEDIDA',
                                id: null,
                                palabrasClaves:[],
                                depuradoPors: [],
                                abrogadoPors:[]
                            };
                        },
                        organosResponse: function(){
                            return null;
                        },
                        documentosResponse:  function(){
                            return null;
                        },
                        actualizaNormaId: function() { 
                            return null; 
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })

        .state('norma-historico', {
            parent: 'entity',
            url: '/norma/{id}/historico',
            data: { authorities: ['ROLE_USER'], pageTitle: 'sgnmrApp.norma.historico.title' },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/norma-historico.html',
                    controller: 'NormaHistoricoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('tipoDisposicion');
                    $translatePartialLoader.addPart('tipoModificacion');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Norma', function($stateParams, Norma) {
                    return Norma.get({id: $stateParams.id}).$promise;
                }],
                historicos: ['$stateParams', 'Norma', function($stateParams, Norma) {
                    return Norma.historicos({id: $stateParams.id}).$promise;
                }]
            }
        })

        .state('norma-historico.nuevo', {
            parent: 'norma-historico',
            url: '/nuevo',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaEmisionPend: false,
                                fechaEmisionPendText: null,
                                fechaPublicacion: null,
                                fechaPublicacionPend: false,
                                fechaPublicacionPendText: null,
                                fechaDOF: null,
                                fechaDOFPend: false,
                                fechaDOFPendText: null,
                                fechaSJFYG: null,
                                fechaSJFYGPend: false,
                                fechaSJFYGPendText: null,
                                fechaSJFGaceta: null,
                                fechaSJFGacetaPend: false,
                                fechaSJFGacetaPendText: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: true,
                                abrogado: false,
                                disposicion: 'EXPEDIDA',
                                id: null,
                                palabrasClaves: [],
                                depuradoPors: [],
                                abrogadoPors: [],
                                // -- lo que lo vuelve un histórico ---
                                esVigente: false,
                                normaVigenteActualId: Number($stateParams.id),
                                tipoModificacion: null,
                                fechaFinVigencia: null
                            };
                        },
                        organosResponse: function() { return null; },
                        documentosResponse: function() { return null; },
                        actualizaNormaId: function() { return null; }
                    }
                }).result.then(function() {
                    $state.go('norma-historico', null, { reload: 'norma-historico' });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-historico.actualizar', {
            parent: 'norma-historico',
            url: '/actualizar',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaEmisionPend: false,
                                fechaEmisionPendText: null,
                                fechaPublicacion: null,
                                fechaPublicacionPend: false,
                                fechaPublicacionPendText: null,
                                fechaDOF: null,
                                fechaDOFPend: false,
                                fechaDOFPendText: null,
                                fechaSJFYG: null,
                                fechaSJFYGPend: false,
                                fechaSJFYGPendText: null,
                                fechaSJFGaceta: null,
                                fechaSJFGacetaPend: false,
                                fechaSJFGacetaPendText: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: true,
                                abrogado: false,
                                disposicion: 'EXPEDIDA',
                                id: null,
                                palabrasClaves: [],
                                depuradoPors: [],
                                abrogadoPors: []
                            };
                        },
                        // No es un histórico: nace en blanco, igual que Crear Norma. Este id solo se usa dentro de save() para ligarla con la norma que va a reemplazar
                        actualizaNormaId: ['$stateParams', function($stateParams) {
                            return Number($stateParams.id);
                        }],
                        organosResponse: function() { return null; },
                        documentosResponse: function() { return null; }
                    }
                }).result.then(function(result) {
                    $state.go('norma-historico', {id: result.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-historico.editar', {
            parent: 'norma-historico',
            url: '/{historicoId}/editar',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.historicoId}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {
                            return OrganoRelevanteNorma.get({id : $stateParams.historicoId}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.historicoId}).$promise;
                        }],
                        actualizaNormaId: function() { return null; }
                    }
                }).result.then(function() {
                    $state.go('norma-historico', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-historico.eliminar', {
            parent: 'norma-historico',
            url: '/{historicoId}/eliminar',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-delete-dialog.html',
                    controller: 'NormaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.historicoId}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {
                            return OrganoRelevanteNorma.get({id : $stateParams.historicoId}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.historicoId}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma-historico', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-historico.vincular', {
            parent: 'norma-historico',
            url: '/vincular',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-historico-vincular-dialog.html',
                    controller: 'NormaHistoricoVincularController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        vigente: ['Norma', function(Norma) {
                            return Norma.get({id: $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma-historico', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-historico.desvincular', {
            parent: 'norma-historico',
            url: '/{historicoId}/desvincular',
            data: { authorities: ['ROLE_USER'] },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-historico-desvincular-dialog.html',
                    controller: 'NormaHistoricoDesvincularController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Norma', function(Norma) {
                            return Norma.get({id: $stateParams.historicoId}).$promise;
                        }],
                        vigenteId: function() {
                            return Number($stateParams.id);
                        }
                    }
                }).result.then(function() {
                    $state.go('norma-historico', {id: $stateParams.id}, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })

        .state('norma-detail', {
            parent: 'norma',
            url: '/norma/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sgnmrApp.norma.detail.title'
            },
            views: {
                'content@private': {
                    templateUrl: 'app/entities/norma/norma-detail.html',
                    controller: 'NormaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('norma');
                    $translatePartialLoader.addPart('tipoDisposicion');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Norma', function($stateParams, Norma) {
                    return Norma.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'norma',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('norma-detail.edit', {
            parent: 'norma-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }],
                        actualizaNormaId: function() { return null; }
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.new', {
            parent: 'norma',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog.html',
                    controller: 'NormaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                denominacion: null,
                                fechaEmision: null,
                                fechaEmisionPend: null,
                                fechaEmisionPendText: null,
                                fechaPublicacion: null,
                                fechaPublicacionPend: null,
                                fechaPublicacionPendText: null,
                                fechaDOF: null,
                                fechaDOFPend: null,
                                fechaDOFPendText: null,
                                fechaSJFYG: null,
                                fechaSJFYGPend: null,
                                fechaSJFYGPendText: null,
                                fechaSJFGaceta: null,
                                fechaSJFGacetaPend: null,
                                fechaSJFGacetaPendText: null,
                                depurado: null,
                                noEsInstrumentoNormativo: null,
                                abstractoConcreto: null,
                                abstractoConcretoContentType: null,
                                validezTemporalFin: null,
                                esCoyuntural: null,
                                estableceMontosEconomicos: null,
                                montosReqAct: null,
                                montosEstFrecAct: null,
                                vigencia: null,
                                showOnlyYear: null,
                                esVisible: null,
                                abrogado: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('norma');
                });
            }]
        })
        .state('norma.edit', {
            parent: 'norma',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-dialog-complete.html',
                    controller: 'NormaDialogCompleteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entityNorma: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }],
                        actualizaNormaId: function() { return null; }
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('norma.delete', {
            parent: 'norma',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/norma/norma-delete-dialog.html',
                    controller: 'NormaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Norma', function(Norma) {
                            return Norma.get({id : $stateParams.id}).$promise;
                        }],
                        organosResponse: ['OrganoRelevanteNorma', function(OrganoRelevanteNorma) {

                            return OrganoRelevanteNorma.get({id : $stateParams.id}).$promise;
                        }],
                        documentosResponse: ['DocumentoNorma', function(DocumentoNorma) {
                            return DocumentoNorma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('norma', null, { reload: 'norma' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
